import loadScript from '@/utils/loadScript'

export default function() {
    loadScript('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js').then(() => {
        function getBaseUrl() {
            return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
        }
        function getConfig() {
          if (window.location.hostname.includes('tongueai.com')) {
            return {
              appid: 'wx979eda058f04a1ec',
              idCode: 'weblogin-tongueai'
            }
          } else {
            return {
              appid: 'wxbbfb191bbca9a8d8',
              idCode: 'weblogin'
            }
          }
        }
        const config = getConfig()
        // console.info(config)
        const redirect = getBaseUrl() + '/backend/integrate/wechatmp/auth/' + config.idCode + '/getUser?returnUrl=api-pc/wx_login/author'
        const cssFileUrl = getBaseUrl() + '/api-pc/static/login/wx-iframe-style-miying.css'
        const appid = config.appid
        setTimeout(function() {
            if (window.WxLogin) {
                /* eslint-disable-next-line */
                var obj = new WxLogin({
                    id: 'qrcode_container',
                    appid: appid,
                    scope: 'snsapi_login',
                    redirect_uri: encodeURIComponent(redirect),
                    state: Math.ceil(Math.random() * 1000),
                    style: 'black',
                    href: cssFileUrl,
                    self_redirect: false
                })
            }
        }, 200)
    })
}



// WEBPACK FOOTER //
// ./src/views/login/wx-login/loadQRCode.js